import { render, staticRenderFns } from "./createLink.vue?vue&type=template&id=65661d82&scoped=true"
import script from "./createLink.vue?vue&type=script&lang=js"
export * from "./createLink.vue?vue&type=script&lang=js"
import style0 from "./createLink.vue?vue&type=style&index=0&id=65661d82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65661d82",
  null
  
)

export default component.exports